import React from "react";

class Page4 extends React.Component {
  state = {
    visible: true,
    question1Answer: null,
    question2Answer: null,
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 4) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }

  saveAnswer1Change = (event) => {
    this.setState({ question1Answer: event.target.value });
    this.props.updatePdf1(event.target.value);
  };

  saveAnswer2Change = (event) => {
    this.setState({ question2Answer: event.target.value });
    this.props.updatePdf2(event.target.value);
  };

  render() {
    return (
      <div>
        {this.state.visible ? (
          <div>
            <nav className="navbar fixed-top navbar-expand-sm bg-light page-title">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <h3 className="py-0  d-md-block">Reflective Questions</h3>
                </li>
              </ul>
            </nav>
            <br />
            <br />
            <div className="container-fluid row d-flex justify-content-center">
              <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12 ">
                <div className="card mb-4 box-shadow h-100 " id="pageContent_2">
                  <ul className="list-group list-group-flush text-dark ">
                    <li className="list-group-item form-card-1">
                      <div className="d-flex">
                        <div className="p-2" id="moduleContentText">
                          Reflect on your top 5 values and ask yourself, “If I
                          could only satisfy one of these, which would I
                          choose?” Reflect on why this particular value is
                          important to you.
                        </div>
                      </div>
                    </li>

                    <li className="list-group-item form-card-2">
                      <div className="d-flex flex-column bd-highlight mb-3 ">
                        <div className="form-group">
                          <textarea
                            className="form-control "
                            id="exampleFormControlTextarea1"
                            placeholder="Enter your answer here..."
                            rows="10"
                            value={this.state.question1Answer}
                            onChange={this.saveAnswer1Change}
                          ></textarea>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <br />
            <br />
            <div className="container-fluid row d-flex justify-content-center">
              <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12 ">
                <div className="card mb-4 box-shadow h-100 " id="pageContent_2">
                  <ul className="list-group list-group-flush text-dark ">
                    <li className="list-group-item form-card-1">
                      <div className="d-flex ">
                        <div className="p-2" id="moduleContentText">
                          What clues do your values give you about your future
                          career direction?
                        </div>
                      </div>
                    </li>

                    <li className="list-group-item form-card-2">
                      <div className="d-flex flex-column bd-highlight mb-3 ">
                        <div className="form-group">
                          <textarea
                            className="form-control "
                            id="exampleFormControlTextarea1"
                            placeholder="Enter your answer here..."
                            rows="10"
                            value={this.state.question2Answer}
                            onChange={this.saveAnswer2Change}
                          ></textarea>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <br />
            <br />
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page4;
